import React from 'react'
import Carousel from 'react-material-ui-carousel'
import dragon from "./../../images/dragon1920.jpg"
import hospital from "./../../images/hoh1920.jpg"
import laserbots from "./../../images/laserbots1920.jpg"
import manor from "./../../images/manor1920.jpg"
import osiris from "./../../images/osiris1920.jpg"
import tiberia from "./../../images/tiberia1920.jpg"
import timetravel from "./../../images/timetravel1920.jpg"
import pirates from "./../../images/pirates_plague1920.jpg"
import runaway from "./../../images/runaway_train1920.jpg"
import {Link} from 'react-router-dom';

//import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
//import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';


export const PictureCarousel = (props) => {
  var items = [
    {
        src: dragon,
        txt: "dragon",
        link: "/Dragon"
    },
    {
        src: osiris,
        txt: "osiris",
        link: "/Osiris"

    },
    {
        src: tiberia,
        txt: "tiberia",
        link: "/Tiberia"

    },
    {
        src: timetravel,
        txt: "timetravel",
        link: "/TimeTravel"

    },
    {
        src: pirates,
        txt: "pirate'splague",
        link: "/Pirates"

    },
    {
        src: laserbots,
        txt: "laserbots",
        link: "/Laserbots"

    },
    {
        src: manor,
        txt: "manor",
        link: "/Manor"

    },
    {
        src: runaway, 
        txt: "runaway train",
        link: "/RunawayTrain"

    }
  ]
  return (
    <>
        <Carousel navButtonsAlwaysVisible={true} indicators={false}>
            {
                items.map( (item, i) => <Item key={i} item={item} /> )
            }
        </Carousel>
      
    </>
  )
}
function Item(props)
{
    return(
    <Link reloadDocument to={props.item.link}>
      <img src={props.item.src} alt={props.item.txt} style={{height:"auto", width:"100%", display:"block", objectFit:"fill"}}/>
    </Link>
    )
}